(function () {
  'use strict';

  const sdkUrl = 'https://www.paypal.com/sdk/js?client-id=AdnAehOeg78ZRgHUDzVCQZy0LVM_saom0ue6YH-6xp4r6bgx3mUGwDsXCLoBvVFrIJIkgi9IXndO3j4d&currency=USD&components=messages';
  let sdkPromise;

  window.theme = window.theme || {};

  function hasMessages(target) {
    const root = typeof target === 'string' ? document.querySelector(target) : target || document;
    return Boolean(root?.querySelector?.('[data-pp-message]') || root?.matches?.('[data-pp-message]'));
  }

  function loadSdk() {
    if (window.paypal?.Messages) return Promise.resolve(window.paypal);
    if (sdkPromise) return sdkPromise;

    sdkPromise = new Promise((resolve, reject) => {
      const existing = document.querySelector('script[data-paypal-messages-sdk]');
      if (existing) {
        existing.addEventListener('load', () => resolve(window.paypal), { once: true });
        existing.addEventListener('error', reject, { once: true });
        return;
      }

      const script = document.createElement('script');
      script.src = sdkUrl;
      script.async = true;
      script.defer = true;
      script.dataset.paypalMessagesSdk = 'true';
      script.onload = () => resolve(window.paypal);
      script.onerror = reject;
      document.head.appendChild(script);
    });

    return sdkPromise;
  }

  theme.loadPayPalMessages = function loadPayPalMessages(target = document) {
    if (!hasMessages(target)) return Promise.resolve(false);

    return loadSdk().then(() => {
      if (!window.paypal?.Messages) return false;

      const selector = typeof target === 'string'
        ? target
        : target?.id
          ? `#${target.id}`
          : '[data-pp-message]';

      window.paypal.Messages().render(selector);
      return true;
    }).catch((error) => {
      console.warn('[PayPal] Failed to load messages SDK:', error);
      return false;
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    theme.loadPayPalMessages(document);
  });
})();
